import React from "react";

import { FrontendOrganization } from "node-library/dist/portal";
import { useTranslation } from "react-i18next";

import { Card } from "@mui/material";

import { formatCustomDate } from "node-library/dist/helpers/date_helper";

interface Props {
	organization: FrontendOrganization;
	goToViewOrgDetails: () => void;
	// discardUnstartedOrder: () => void;
}

export default function OrganizationCell(props: Props) {
	const { t: translation } = useTranslation();

	const {
		goToViewOrgDetails,
		organization,
		// discardUnstartedOrder,
	} = props;

	let actionOptions: Array<{
		key: string;
		onClick: () => void;
		children: React.ReactNode;
	}>;

	const userHeaderRow: React.ReactNode = (
		<div
			style={{
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				gap: "5px",
			}}
		>
			{/* <div
				className="typography-caption sample-status-box"
				style={{
					backgroundColor: statusColor.backgroundColor,
					border: `1px solid ${statusColor.borderColor}`,
					color: statusColor.textColor,
				}}
			>
				{statusString}
			</div> */}

			{/* <KebabDropdownButton
				menuOptions={actionOptions}
				id={`batch-more-action-menu-${order.orderBarcodeId}`}
				onClick={(e) => {}}
			></KebabDropdownButton> */}
		</div>
	);
	const userBody: React.ReactNode = (
		<div
			style={{
				marginTop: "10px",
				display: "flex",
				flexDirection: "column",
				gap: "5px",
			}}
		>
			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">
					{translation("AssociationId")}
				</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{organization.associationId}
				</div>
			</div>
			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">
					{translation("CompanyName")}
				</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{organization.clientCompanyName}
				</div>
			</div>

			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">
					{translation("Address")}
				</div>
				<div
					className="overflow-ellipsis-text"
					style={{ maxWidth: "50%", textAlign: "right" }}
				>
					<div>{`${organization.address}, `}</div>
					<div>{`${organization.city}, ${organization.province}, ${organization.country} `}</div>
					<div>{organization.postalCode}</div>
				</div>
			</div>

			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">
					{translation("SalesRep")}
				</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{organization.salesFullName || translation("None")}
				</div>
			</div>

			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">
					{translation("Createdon")}
				</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{formatCustomDate(organization.inserted as Date)}
				</div>
			</div>
		</div>
	);

	return (
		<Card
			className="card-border-radius-14p card-medium-padding highlight-card"
			style={{ cursor: "pointer" }}
			key={organization.organizationId}
			onClick={() => {
				goToViewOrgDetails();
			}}
		>
			{userHeaderRow}
			{userBody}
		</Card>
	);
}
